import { addDoc, collection, doc, onSnapshot, serverTimestamp, setDoc } from 'firebase/firestore';
import { db } from './firebase';

const LOCAL_KEY = 'gearnode_custom_catalog_v1';
const catalogRef = uid => doc(db, 'artifacts', 'gearnode-prod-v1', 'users', uid, 'settings', 'custom-catalog');

export function loadCustomCatalog() {
  try {
    const items = JSON.parse(localStorage.getItem(LOCAL_KEY));
    return Array.isArray(items) ? items : [];
  } catch { return []; }
}

export function parsePortLines(value = '', direction = 'port') {
  return value.split('\n').map(line => line.trim()).filter(Boolean).map((line, index) => {
    const [namePart, typePart] = line.split('|').map(part => part?.trim());
    const name = namePart || `${direction} ${index + 1}`;
    const type = typePart || name;
    return { id: `${direction}-${index + 1}-${type.toLowerCase().replace(/[^a-z0-9]+/g, '-')}`, name, type };
  });
}

export function createCustomDevice(data) {
  const id = typeof crypto !== 'undefined' && crypto.randomUUID ? `custom-${crypto.randomUUID()}` : `custom-${Date.now()}`;
  return {
    id,
    brand: data.brand?.trim() || 'Własny',
    model: data.model?.trim() || 'Urządzenie',
    type: data.type?.trim() || 'Inne',
    category: data.category || 'video',
    assetKind: data.assetKind || 'equipment',
    power: Math.max(0, Number(data.power) || 0),
    inputs: data.inputs || parsePortLines(data.inputPorts, 'in'),
    outputs: data.outputs || parsePortLines(data.outputPorts, 'out'),
    voltage: data.voltage?.trim() || '',
    supportedFormats: typeof data.supportedFormats === 'string'
      ? data.supportedFormats.split(',').map(item => item.trim()).filter(Boolean)
      : (data.supportedFormats || []),
    custom: true,
    submissionStatus: data.submitToCatalog ? 'pending' : 'private',
  };
}

export async function saveCustomCatalog(user, items) {
  localStorage.setItem(LOCAL_KEY, JSON.stringify(items));
  if (!user || user.isAnonymous) return;
  await setDoc(catalogRef(user.uid), { items, updatedAt: Date.now() }, { merge: true });
}

export function subscribeCustomCatalog(user, onData, onError) {
  if (!user || user.isAnonymous) return () => {};
  return onSnapshot(catalogRef(user.uid), snapshot => {
    if (snapshot.exists()) onData(snapshot.data().items || []);
  }, onError);
}

export async function submitCustomDevice(user, device) {
  if (!user || user.isAnonymous) return;
  await addDoc(collection(db, 'catalogSubmissions'), {
    device,
    ownerId: user.uid,
    ownerEmail: user.email || '',
    status: 'pending',
    createdAt: serverTimestamp(),
  });
}
